<ng-container *ngFor="let section of sections">
  <app-section-generator [section]="section"></app-section-generator>
</ng-container>
